import React from "react"
import { styled } from "@mui/material/styles"
import { css } from '@emotion/react';

const SaleCountDownContainer = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #4d4d4d;
  border-radius: 12px;
  color: white;
  padding: 10px 20px;
  margin-bottom: 20px;
`

const TimeBlock = styled('div')`
  width: 72px;
  background-color: black;
  color: white;
  margin: 0 5px;
  text-align: center;
  font-weight: 800;
  border-radius: 5px;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5px;
  height: fit-content;

  @media (max-width: 750px) {
    font-size: 10px;
  }
`

const TimeNumber = styled('div')`
  font-size: 30px;
  @media (max-width: 750px) {
    font-size: 20px;
  }
`

class SaleCountdown extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      timeRemaining: this.calculateTimeRemaining(),
    }
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this.setState({
        timeRemaining: this.calculateTimeRemaining(),
      });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  calculateTimeRemaining() {
    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    return midnight - now;
  }

  render() {
    const { timeRemaining } = this.state
    const hours = Math.floor(timeRemaining / 3600000)
    const minutes = Math.floor((timeRemaining % 3600000) / 60000)
    const seconds = Math.floor((timeRemaining % 60000) / 1000)

    if (timeRemaining <= 0) {
      return <div className="flow-text">Time's up!</div>
    }

    return (
      <SaleCountDownContainer>
        <span
          className="bold flow-text"
          css={css`
            align-self: center;
            margin-right: 20px;
          `}
          role="heading"
          aria-level="2"
        >
          50% Discount Ends Tonight
        </span>
        <TimeBlock>
          <TimeNumber>0</TimeNumber> Days
        </TimeBlock>
        <TimeBlock>
          <TimeNumber>{hours}</TimeNumber> Hours
        </TimeBlock>
        <TimeBlock>
          <TimeNumber>{minutes}</TimeNumber> Minutes
        </TimeBlock>
        <TimeBlock>
          <TimeNumber>{seconds}</TimeNumber> Seconds
        </TimeBlock>
      </SaleCountDownContainer>
    )
  }
}

export default SaleCountdown
